import type { ImgHTMLAttributes } from "react"
import { cn } from "@/lib/utils"

export function BrandMark({ className, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  return (
    // biome-ignore lint/performance/noImgElement: This tiny local SVG is already the optimized brand source in the Vite build.
    <img
      src="/resolto-mark.svg"
      alt=""
      className={cn("size-8", className)}
      aria-hidden="true"
      {...props}
    />
  )
}
